import React from "react";
import type { ExportTemplate, OrderExportForm } from "../types/orderExportTypes";
import { ExportOptionRow } from "./ExportOptionRow";

interface Props {
  form: OrderExportForm;
  update: (patch: Partial<OrderExportForm>) => void;
  templates: ExportTemplate[];
  file?: File;
  fileName: string;
  setFile: (file?: File) => void;
  upload: () => void;
  uploading: boolean;
  invalid: boolean;
}

export const ExportTemplateCard = ({ form, update, templates, file, fileName, setFile, upload, uploading, invalid }: Props) => (
  <section className="tw-rounded-xl tw-border tw-border-slate-200/60 tw-bg-white tw-p-5 tw-shadow-sm dark:tw-bg-slate-800/60">
    <h2 className="tw-text-sm tw-font-semibold tw-text-slate-800 dark:tw-text-white">Template and format</h2>
    <div className="tw-mt-2">
      <ExportOptionRow label="Saved template" error={invalid}>
        <select value={file ? "" : form.templateUrl} disabled={Boolean(file)} onChange={(e) => update({ templateUrl: e.target.value })} className="tw-h-9 tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-text-sm disabled:tw-bg-slate-100 dark:tw-bg-slate-900" data-testid="export-template-selection">
          <option value="">Select a template</option>
          {templates.map((item) => <option key={item.id} value={item.url}>{item.name}</option>)}
        </select>
      </ExportOptionRow>
      <ExportOptionRow label="Upload template">
        <div className="tw-flex tw-flex-col tw-gap-2 sm:tw-flex-row sm:tw-items-center">
          <input type="file" accept=".csv,.xls,.xlsx,.ods" disabled={Boolean(form.templateUrl) || uploading} onChange={(e) => { const selected = e.target.files?.[0]; setFile(selected); update({ templateUrl: "" }); }} className="tw-h-9 tw-min-w-0 tw-flex-1 tw-rounded-lg tw-border tw-border-dashed tw-border-slate-300 tw-p-1.5 tw-text-xs disabled:tw-bg-slate-100" data-testid="input-upload-file" />
          {file && <><span className="tw-max-w-40 tw-truncate tw-text-xs tw-text-slate-500">{fileName || file.name}</span><button type="button" className="tw-text-xs tw-text-red-600" onClick={() => setFile(undefined)}>Clear</button>{!form.templateUrl && <button type="button" onClick={upload} disabled={uploading} className="tw-h-9 tw-rounded-lg tw-bg-primary tw-px-3 tw-text-xs tw-font-semibold tw-text-white">{uploading ? "Uploading…" : "Upload"}</button>}</>}
        </div>
      </ExportOptionRow>
      <ExportOptionRow label="File format">
        <select value={form.fileType} onChange={(e) => update({ fileType: e.target.value })} className="tw-h-9 tw-w-full tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2.5 tw-text-sm" data-testid="file-type-selection"><option value="">Select file format</option><option value="headerLess">HeaderLess</option><option value="header">Header</option></select>
      </ExportOptionRow>
    </div>
  </section>
);
